import React, { memo, useEffect, useRef, useState } from 'react';

import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';

import * as _ from 'lodash';

import { translate } from 'react-i18next';
import { usePrevious } from 'lib/useHook';

function ChartRangeMarket(props) {
  const chartComponent = useRef(null);
  const [chartOptions, setChartOptions] = useState(null);

  const { data, t } = props;

  const preData = usePrevious(data);

  useEffect(() => {
    if (data && !_.isEqual(data, preData)) {
      _mapDataToState(data);
    }
  }, [data]);

  function _mapDataToState(stockHis) {
    const noChanges = _.map(stockHis, 'NoChanges');
    const advances = _.map(stockHis, 'Advances');
    const declines = _.map(stockHis, 'Declines');
    const dateSeries = _.map(stockHis, 'Time');

    let _cata = [];

    dateSeries.forEach((element) => {
      const _ii = element.split(':');
      _cata.push(_ii[0] + ':' + _ii[1]);
    });

    const _chartOptions = {
      colors: ['#0FC786', '#F0B90B', '#F5465C'],
      chart: {
        type: 'area',
        backgroundColor: props.theme === 'dark'? '#110e1e' : '#ffffff',
        spacingBottom: 10,
        spacingTop: 5,
      },
      title: {
        text: ' ',
      },
      accessibility: {
        point: {
          valueDescriptionFormat:
            '{index}. {point.category}, {point.y:,.0f}, {point.percentage:.1f}%.',
        },
      },
      xAxis: [
        {
          gridLineWidth: 0,
          lineWidth: 0,
          tickWidth: 0,
          categories: _cata,
          crosshair: true,
          tickmarkPlacement: 'on',
          title: {
            enabled: false,
          },
          labels: {
            style: {
              fontSize: '8px',
              fontColor: '#83817C',
            },
          },
        },
      ],
      yAxis: {
        gridLineWidth: 0,
        labels: {
          format: '{value}',
        },
        title: {
          text: t('txt-rate') + ' %',
        },
        style: {
          fontsize: '8px',
        },
      },
      tooltip: {
        // pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.1f}%</b> ({point.y:,.0f})<br/>',
        pointFormat: '<span>{series.name}</span>: <b>{point.percentage:.1f}%</b> ({point.y:,.0f})<br/>',
        split: true,
        // backgroundColor: '#1c192c',
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        area: {
          stacking: 'percent',
          lineWidth: 0,
          marker: {
            lineWidth: 0,
          },
        },
        series: {
          marker: {
            enabled: false
          }
        }
      },
      series: [
        {
          name: t('algo.pttt.txt-advance'),
          data: advances,
        },
        {
          name: t('algo.pttt.txt-no-change'),
          data: noChanges,
        },
        {
          name: t('algo.pttt.txt-decline'),
          data: declines,
        },
      ],
    };
    setChartOptions(_chartOptions);
  }

  return (
    <HighchartsReact
      ref={chartComponent}
      highcharts={Highcharts}
      options={chartOptions}
      containerProps={{ style: { height: '100%' } }}
    />
  );
}

export default translate('translations')(memo(ChartRangeMarket));
